import ErrorPage from "@/components/pages/ErrorPage";
import { AuthLayout } from "@/features/auth/components/layout";
import { useAuthCopy } from "@/features/i18n/authCopy";
import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
    component: Auth,
    errorComponent: ({ error, reset }) => <AuthErrorPage error={error} reset={reset} />,
});

function AuthErrorPage({ error, reset }: { error: Error; reset: () => void }) {
    const copy = useAuthCopy();
    return <ErrorPage title={copy.authErrorTitle} error={error} reset={reset} />;
}

function Auth() {
    const matches = useMatches();
    const cardVariant = matches.some((match) => match.routeId === "/_auth/_public/signup/$plan") ? "wide" : "default";

    return (
        <AuthLayout cardVariant={cardVariant}>
            <Outlet />
        </AuthLayout>
    );
}
